// Single source of truth for pipeline stage order/labels/colors on the frontend.
// Must stay in sync with STAGES in backend/server.py.
export const STAGES = [
  { id: "New Client", accent: "#8B5CF6" },
  { id: "Konsultasi", accent: "#3B82F6" },
  { id: "Survei", accent: "#06B6D4" },
  { id: "SPH", accent: "#F59E0B" },
  { id: "Closing", accent: "#10B981" },
  { id: "Lost", accent: "#EF4444" },
];
export const STAGE_IDS = STAGES.map((s) => s.id);
export const STAGE_ACCENT = Object.fromEntries(STAGES.map((s) => [s.id, s.accent]));
export const TRASH_STATUS = "Tidak Jelas";
export const ALL_STATUSES = [...STAGE_IDS, TRASH_STATUS];
// Stages where a lead is still being actively worked (drives aging/idle indicators).
export const ACTIVE_STAGES = ["New Client", "Konsultasi", "Survei", "SPH"];
export const DEFAULT_STATUS = "New Client";
